<template>
  <div class="custom-file-input-box">
    <div class="custom-file-input-box__input-title">{{ title }}</div>
    <div class="custom-file-input-box__wrapper">
      <div class="custom-file-input-box__content">
        <input type="file" ref="file" @change="setFile" />

        <div class="custom-file-input-box__content__selected" v-if="file">
          <div class="custom-file-input-box__content__selected__title">
            <div>Arquivo selecionado:</div>
            <div>{{ file?.name }}</div>
          </div>
        </div>
        <div
          class="custom-file-input-box__content__not-selected clickable"
          @click="$refs.file.click()"
          v-else
        >
          <div>
            <div class="custom-file-input-box__content__not-selected__title">
              Selecione um arquivo
            </div>
            <div class="custom-file-input-box__content__not-selected__icon">
              <font-awesome-icon
                :icon="['fas', 'hand-pointer']"
              ></font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-file-input-box__actions">
        <div class="option option__delete" @click="file = null" v-if="file">
          <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
    },
    emits: ['file-changed-event'],
    data() {
      return {
        file: null,
      }
    },
    methods: {
      setFile(event) {
        const file = event.target.files[0]

        this.file = file
      },
    },
    watch: {
      file(newValue) {
        this.$emit('file-changed-event', { file: newValue })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .custom-file-input-box {
    &__wrapper {
      position: relative;

      border: 1px solid #dee2e6;
      border-radius: 4px;
      min-height: 200px;
    }

    &__content {
      height: 100%;
      width: 100%;

      position: absolute;
      top: 0;
      left: 0;

      &__selected {
        height: 100%;

        text-align: center;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &__title {
          color: #909090;
        }
      }

      &__not-selected {
        height: 100%;
        color: #cacaca;
        font-size: 1.5rem;

        text-align: center;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &__icon {
          font-size: 3rem;
        }
      }

      input[type='file'] {
        display: none;
      }
    }

    &__actions {
      position: absolute;

      bottom: 10px;
      right: 10px;
      width: auto;

      display: flex;

      .option {
        $defaultColor: rgb(76, 175, 80);

        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        color: white;

        padding: 5px;
        width: 30px;
        height: 30px;

        border: 2px solid #ccc;
        color: $defaultColor;

        transition: box-shadow 0.5s ease, background-color 0.3s ease;

        &:hover {
          border: none;
          box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

          background-color: $defaultColor;

          color: white;
        }

        &:not(:first-child) {
          margin-left: 5px;
        }

        &__delete {
          color: rgb(244, 67, 54);

          &:hover {
            box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

            background-color: rgb(244, 67, 54);
          }
        }
      }
    }
  }
</style>
